 <script>
  import * as animateScroll from "svelte-scrollto";
  export let siteLinks;

  function closeNavbar() {
    let navBar =  document.getElementById('navbarNavAltMarkup');
    navBar.classList.remove("show");
  }

  function scrollToTop() {
    animateScroll.scrollToTop();
    closeNavbar();
  }

  const { pathname } = window.location;
  let activeLink = '';
  if(pathname == '/pricing') { activeLink = 'pricing-bar'; }
  if(pathname == '/features') { activeLink = 'features-bar'; }

 </script>
<header class="fixed-top">
  <div class="container">
    <nav id="main-nav" class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <a class="navbar-brand" href="/" on:click={() => { scrollToTop(); activeLink=''; }}><img class="img-fluid logo" src="assets/img/logo.svg" alt=""></a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div class="navbar-nav ms-auto {activeLink == 'feature-is-ready' && activeLink}">
            <a class="nav-link mt-1 px-5 text-light" on:click={() => { scrollToTop(); activeLink='features-bar'; }} href="{siteLinks.features}">Features</a>
            <a class="nav-link mt-1 px-5 text-light" on:click={() => { scrollToTop(); activeLink='pricing-bar'; }} href="{siteLinks.pricing}">Pricing</a>
            <a class="nav-link px-5" href="#app-links" on:click={closeNavbar} ><button type="button"
                class="btn btn-secondary bg-light px-4 py-2 fw-bold btn-app">Get The App</button></a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</header>